import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

const reflow = (elem) => elem.offsetHeight;

/* eslint-disable react/no-string-refs */

const transitions = {
  easeOut(duration, property, delay, easeFunction) {
    if (property && Object.prototype.toString.call(property) === '[object Array]') {
      let transitions = ''; // eslint-disable-line no-shadow
      for (let i = 0; i < property.length; i += 1) {
        // eslint-disable-line no-plusplus
        if (transitions) {
          transitions += ',';
        }
        transitions += this.create(duration, property[i], delay, easeFunction);
      }

      return transitions;
    }
    return this.create(duration, property, delay, easeFunction);
  },

  create(duration = '450ms', property = 'all', delay = '0ms', easeFunction = 'linear') {
    return `${property} ${duration} ${easeFunction} ${delay}`;
  },
};

class ExpandTransitionChild extends Component {
  componentWillUnmount() {
    clearTimeout(this.enterTimer);
    clearTimeout(this.enteredTimer);
    clearTimeout(this.leaveTimer);
  }

  setAutoHeight() {
    const { style } = ReactDOM.findDOMNode(this); // eslint-disable-line react/no-find-dom-node
    style.transitionDuration = 0;
    style.height = 'auto';
  }

  componentWillLeave(callback) {
    const { transitionDelay, transitionDuration } = this.props;
    const element = ReactDOM.findDOMNode(this); // eslint-disable-line react/no-find-dom-node
    // Set fixed height first for animated property value
    element.style.height = `${this.refs.wrapper.clientHeight}px`;
    reflow(element);
    element.style.transitionDuration = `${transitionDuration}ms`;
    element.style.height = 0;
    this.leaveTimer = setTimeout(() => callback(), transitionDelay + transitionDuration);
  }

  componentDidEnter() {
    this.setAutoHeight();
  }

  componentWillEnter(callback) {
    const { enterDelay, transitionDelay, transitionDuration } = this.props;
    const element = ReactDOM.findDOMNode(this); // eslint-disable-line react/no-find-dom-node
    element.style.height = 0;
    this.enterTimer = setTimeout(() => this.open(), enterDelay);
    this.enteredTimer = setTimeout(
      () => callback(),
      enterDelay + transitionDelay + transitionDuration
    );
  }

  componentDidAppear() {
    this.setAutoHeight();
  }

  componentWillAppear(callback) {
    this.open();
    callback();
  }

  open() {
    const element = ReactDOM.findDOMNode(this); // eslint-disable-line react/no-find-dom-node
    element.style.height = `${this.refs.wrapper.clientHeight}px`;
  }

  render() {
    const {
      children,
      enterDelay, // eslint-disable-line no-unused-vars
      style,
      transitionDelay, // eslint-disable-line no-unused-vars
      transitionDuration,
      ...other
    } = this.props;

    const mergedRootStyles = {
      position: 'relative',
      // height: 0,
      width: '100%',
      top: 0,
      left: 0,
      overflow: 'hidden',
      transition: transitions.easeOut(
        `${transitionDuration}ms`,
        ['height'],
        `${transitionDelay}ms`
      ),
      ...style,
    };

    return (
      <div {...other} style={mergedRootStyles}>
        <div ref="wrapper">{children}</div>
      </div>
    );
  }
}

ExpandTransitionChild.propTypes = {
  children: PropTypes.node,
  enterDelay: PropTypes.number,
  style: PropTypes.object,
  transitionDelay: PropTypes.number,
  transitionDuration: PropTypes.number,
};

ExpandTransitionChild.defaultProps = {
  enterDelay: 0,
  transitionDelay: 0,
  transitionDuration: 450,
};

export default ExpandTransitionChild;
